
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Messages.css";

import ForexBottomNav from "../Components/ForexBottomNav";
import ForexHeader from "./ForexHeader";

const botChannels = [
  {
    id: 1,
    name: "AI Forex Analyse",
    description:
      "AI analyzes EURUSD, GBPUSD, USDJPY and shares market insights.",
    image:
      "https://placehold.co/100x100/17113b/ffffff?text=AI+FX",
    category: "Forex",
  },
  {
    id: 2,
    name: "AI Gold & Oil Analyse",
    description:
      "AI analyzes GOLD, WTI CRUDE OIL and shares market insights.",
    image:
      "https://placehold.co/100x100/38250c/ffffff?text=GOLD",
    category: "Gold",
  },
  {
    id: 3,
    name: "Overview of current FX Market.",
    description:
      "Overview of the current FX market and market opportunities.",
    image:
      "https://placehold.co/100x100/063b32/ffffff?text=FX",
    category: "Forex",
  },
  {
    id: 4,
    name: "LEO ANALYSIS",
    description:
      "Welcome to the official analysis channel.",
    image:
      "https://placehold.co/100x100/172344/ffffff?text=LEO",
    category: "Signals",
  },
  {
    id: 5,
    name: "AI Stocks Analyse",
    description:
      "AI analyzes US stocks and shares market insights.",
    image:
      "https://placehold.co/100x100/451047/ffffff?text=STOCKS",
    category: "Stocks",
  },
  {
    id: 6,
    name: "Xauusd Signal",
    description:
      "Free signals and analysis for Gold.",
    image:
      "https://placehold.co/100x100/51280b/ffffff?text=XAUUSD",
    category: "Gold",
  },
  {
    id: 7,
    name: "Golden Hen Community",
    description:
      "Announcements and community updates.",
    image:
      "https://placehold.co/100x100/45400a/ffffff?text=COMMUNITY",
    category: "Community",
  },
  {
    id: 8,
    name: "TRADING BOT CHANNEL",
    description:
      "Automated trading information and market updates.",
    image:
      "https://placehold.co/100x100/123c47/ffffff?text=BOT",
    category: "Bots",
  },
  {
    id: 9,
    name: "Savia Signals - Volatility Switch",
    description:
      "High Quality Volatility Switch Signals.",
    image:
      "https://placehold.co/100x100/252019/ffffff?text=SAVIA",
    category: "Signals",
  },
  {
    id: 10,
    name: "Savia Signals - Jump Index",
    description:
      "High Quality Jump Index Signals.",
    image:
      "https://placehold.co/100x100/252019/ffffff?text=JUMP",
    category: "Signals",
  },
  {
    id: 11,
    name: "Jazimine livetrades",
    description:
      "Live Gold and Forex trading updates.",
    image:
      "https://placehold.co/100x100/29312a/ffffff?text=LIVE",
    category: "Forex",
  },
  {
    id: 12,
    name: "Daily Forex News",
    description:
      "Daily news on forex, stocks, gold and crypto.",
    image:
      "https://placehold.co/100x100/17324b/ffffff?text=NEWS",
    category: "News",
  },
];

export default function Messages() {
  const navigate = useNavigate();

  // Pata username kutoka localStorage
  const username =
    localStorage.getItem("username") || "User";

  const [search, setSearch] = useState("");
  const [selectedBot, setSelectedBot] = useState(null);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  // Tafuta bots na channels
  const filteredBots = useMemo(() => {
    const value = search.trim().toLowerCase();

    if (!value) {
      return botChannels;
    }

    return botChannels.filter((bot) =>
      `${bot.name} ${bot.description} ${bot.category}`
        .toLowerCase()
        .includes(value)
    );
  }, [search]);

  // Fungua Coming Soon
  const openBot = (bot) => {
    setSelectedBot(bot);
    setShowComingSoon(true);
  };

  // Funga Coming Soon
  const closeComingSoon = () => {
    setShowComingSoon(false);
    setSelectedBot(null);
  };

  // Back button
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="messages-page">

      {/* MAIN FOREX HEADER */}
      <ForexHeader />

      {/* MESSAGES HEADER */}
      <header className="messages-topbar">

        <button
          className="messages-icon-button"
          type="button"
          aria-label="Go back"
          onClick={handleBack}
        >
          ‹
        </button>

        {/* USERNAME KUTOKA LOCAL STORAGE */}
        <div
          className="messages-account-title"
          title={username}
        >
          {username}
        </div>

        <span className="messages-account-tag">
          MQID
        </span>

        {/* SEARCH BUTTON */}
        <button
          className="messages-icon-button"
          type="button"
          aria-label="Search channels"
          onClick={() => {
            document
              .querySelector(".messages-search-input")
              ?.focus();
          }}
        >
          ⌕
        </button>

        {/* CREATE CHANNEL */}
        <button
          className="messages-icon-button"
          type="button"
          aria-label="Create channel"
          onClick={() =>
            openBot({ name: "Create Channel" })
          }
        >
          +
        </button>

        {/* MORE OPTIONS */}
        <button
          className="messages-icon-button"
          type="button"
          aria-label="More options"
          aria-expanded={showMenu}
          onClick={() => setShowMenu((value) => !value)}
        >
          ⋮
        </button>
      </header>

      {/* DROPDOWN MENU */}
      {showMenu && (
        <div className="messages-dropdown">

          <button
            type="button"
            onClick={() => {
              setShowMenu(false);
              openBot({ name: "Settings" });
            }}
          >
            ⚙️ Settings
          </button>

          <button
            type="button"
            onClick={() => {
              setShowMenu(false);
              openBot({ name: "Create Channel" });
            }}
          >
            ＋ Create channel
          </button>

          <button
            type="button"
            onClick={() => setShowMenu(false)}
          >
            Close menu
          </button>

        </div>
      )}

      {/* SEARCH */}
      <div className="messages-search">

        <span aria-hidden="true">
          ⌕
        </span>

        <input
          className="messages-search-input"
          type="search"
          placeholder="Search bots and channels..."
          value={search}
          onChange={(event) =>
            setSearch(event.target.value)
          }
          aria-label="Search bots and channels"
        />

        {search && (
          <button
            type="button"
            onClick={() => setSearch("")}
            aria-label="Clear search"
          >
            ×
          </button>
        )}

      </div>

      {/* CHANNEL LIST */}
      <main className="messages-list">

        <div className="messages-section-heading">
          {search
            ? "SEARCH RESULTS"
            : "POPULAR CHANNELS"}
        </div>

        {filteredBots.length === 0 ? (
          <div className="messages-empty">

            <span aria-hidden="true">
              ⌕
            </span>

            <strong>
              No channels found
            </strong>

            <p>
              Jaribu kutafuta kwa jina jingine.
            </p>

          </div>
        ) : (
          filteredBots.map((bot) => (
            <button
              key={bot.id}
              type="button"
              className="messages-channel"
              onClick={() => openBot(bot)}
            >
              <img
                className="messages-channel-image"
                src={bot.image}
                alt={bot.name}
                loading="lazy"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src =
                    "https://placehold.co/100x100/171717/ffffff?text=BOT";
                }}
              />

              <span className="messages-channel-info">

                <span className="messages-channel-title">
                  {bot.name}
                </span>

                <span className="messages-channel-description">
                  {bot.description}
                </span>

              </span>
            </button>
          ))
        )}

      </main>

      {/* COMING SOON MODAL */}
      {showComingSoon && (
        <div
          className="messages-modal-overlay"
          onClick={closeComingSoon}
          role="presentation"
        >
          <section
            className="messages-coming-soon"
            role="dialog"
            aria-modal="true"
            aria-labelledby="messages-coming-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="messages-modal-close"
              onClick={closeComingSoon}
              aria-label="Close dialog"
            >
              ×
            </button>

            <div className="messages-coming-icon">
              🤖
            </div>

            <h2 id="messages-coming-title">
              {selectedBot?.name || "Bot"}
            </h2>

            <div className="messages-coming-label">
              COMING SOON
            </div>

            <p>
              Kipengele hiki kinatayarishwa.
              Kitapatikana hivi karibuni.
            </p>

            <button
              type="button"
              className="messages-coming-button"
              onClick={closeComingSoon}
            >
              Sawa
            </button>

          </section>
        </div>
      )}

      {/* FOREX BOTTOM NAVIGATION */}
      <ForexBottomNav />

    </div>
  );
}
